module.exports = __webpack_public_path__ + "static/img/t1-2-1.0d30a77.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/product/t1-2-1.png
// module id = NrRO
// module chunks = 1